export type ReadRootGetApiResponse = /** status 200 Successful Response */ any;
export type ReadRootGetApiArg = void;
export type GetCurrentUserProfileApiResponse = /** status 200 Successful Response */ UserRead;
export type GetCurrentUserProfileApiArg = void;
export type UpdateCurrentUserProfileApiResponse = /** status 200 Successful Response */ UserRead;
export type UpdateCurrentUserProfileApiArg = {
  updates: {
    [key: string]: any;
  };
};
export type GetCurrentUserAccountsApiResponse = /** status 200 Successful Response */ AccountWithRoles[];
export type GetCurrentUserAccountsApiArg = void;
export type GetUserProfileByIdApiResponse = /** status 200 Successful Response */ UserRead;
export type GetUserProfileByIdApiArg = {
  userId: string;
};
export type ListAllUserProfilesApiResponse = /** status 200 Successful Response */ UserRead[];
export type ListAllUserProfilesApiArg = void;
export type UpdateUserProfileStatusApiResponse = /** status 200 Successful Response */ UserRead;
export type UpdateUserProfileStatusApiArg = {
  userId: string;
  newStatus: string;
};
export type CreateAccountApiResponse = /** status 200 Successful Response */ AccountRead;
export type CreateAccountApiArg = void;
export type GetCurrentAccountProfileApiResponse = /** status 200 Successful Response */ AccountRead;
export type GetCurrentAccountProfileApiArg = void;
export type UpdateCurrentAccountDetailsApiResponse = /** status 200 Successful Response */ AccountRead;
export type UpdateCurrentAccountDetailsApiArg = {
  updates: {
    [key: string]: any;
  };
};
export type DeactivateCurrentAccountApiResponse = /** status 200 Successful Response */ {
  [key: string]: any;
};
export type DeactivateCurrentAccountApiArg = void;
export type ReactivateCurrentAccountApiResponse = /** status 200 Successful Response */ {
  [key: string]: any;
};
export type ReactivateCurrentAccountApiArg = void;
export type TransferAccountOwnershipApiResponse = /** status 200 Successful Response */ {
  [key: string]: any;
};
export type TransferAccountOwnershipApiArg = {
  newOwnerEmail: string;
};
export type GetAccountByIdApiResponse = /** status 200 Successful Response */ AccountRead;
export type GetAccountByIdApiArg = {
  accountId: string;
};
export type UpdateAccountDetailsApiResponse = /** status 200 Successful Response */ AccountRead;
export type UpdateAccountDetailsApiArg = {
  accountId: string;
  updates: {
    [key: string]: any;
  };
};
export type DeleteAccountApiResponse = /** status 200 Successful Response */ {
  [key: string]: any;
};
export type DeleteAccountApiArg = {
  accountId: string;
};
export type ListAllAccountsApiResponse = /** status 200 Successful Response */ AccountRead[];
export type ListAllAccountsApiArg = void;
export type RemoveMemberFromCurrentAccountApiResponse = /** status 200 Successful Response */ {
  [key: string]: any;
};
export type RemoveMemberFromCurrentAccountApiArg = {
  userEmail: string;
};
export type InviteMemberToAccountApiResponse = /** status 200 Successful Response */ UserRead;
export type InviteMemberToAccountApiArg = {
  inviteeEmail: string;
  role: string;
};
export type ListAccountMembersApiResponse = /** status 200 Successful Response */ MemberRead[];
export type ListAccountMembersApiArg = void;
export type SetCurrentAccountMemberRolesApiResponse = /** status 200 Successful Response */ any;
export type SetCurrentAccountMemberRolesApiArg = {
  userEmail: string;
  roles: string[];
};
export type SubscribeAccountToProductApiResponse = /** status 200 Successful Response */ SubscriptionRead;
export type SubscribeAccountToProductApiArg = {
  accountId: string;
  subscriptionCreate: SubscriptionCreate;
};
export type ListSubscriptionsForAccountApiResponse = /** status 200 Successful Response */ SubscriptionRead[];
export type ListSubscriptionsForAccountApiArg = {
  accountId: string;
};
export type CancelSubscriptionForCurrentAccountApiResponse = /** status 200 Successful Response */ {
  [key: string]: any;
};
export type CancelSubscriptionForCurrentAccountApiArg = {
  subscriptionId: string;
};
export type AddRoleToMemberApiResponse = /** status 200 Successful Response */ {
  [key: string]: any;
};
export type AddRoleToMemberApiArg = {
  accountId: string;
  userEmail: string;
  role: string;
};
export type RemoveRoleFromMemberApiResponse = /** status 200 Successful Response */ {
  [key: string]: any;
};
export type RemoveRoleFromMemberApiArg = {
  accountId: string;
  userEmail: string;
  role: string;
};
export type SubscribeAccountToProductConfigManagerCloudServicesApiV1SubscriptionsPostApiResponse =
  /** status 200 Successful Response */ SubscriptionRead;
export type SubscribeAccountToProductConfigManagerCloudServicesApiV1SubscriptionsPostApiArg = {
  subscriptionCreate: SubscriptionCreate;
};
export type ListAccountSubscriptionsConfigManagerCloudServicesApiV1SubscriptionsCurrentGetApiResponse =
  /** status 200 Successful Response */ SubscriptionRead[];
export type ListAccountSubscriptionsConfigManagerCloudServicesApiV1SubscriptionsCurrentGetApiArg = void;
export type DeleteSubscriptionApiResponse = /** status 200 Successful Response */ {
  [key: string]: any;
};
export type DeleteSubscriptionApiArg = {
  subscriptionId: string;
};
export type GetCurrentBillingProfileApiResponse = /** status 200 Successful Response */ BillingProfileRead;
export type GetCurrentBillingProfileApiArg = void;
export type UpdateCurrentBillingProfileApiResponse = /** status 200 Successful Response */ {
  [key: string]: any;
};
export type UpdateCurrentBillingProfileApiArg = {
  billingUpdates: {
    [key: string]: any;
  };
};
export type ListProductCatalogConfigManagerCloudServicesApiV1ProductCatalogGetApiResponse =
  /** status 200 Successful Response */ ProductCatalogRead[];
export type ListProductCatalogConfigManagerCloudServicesApiV1ProductCatalogGetApiArg = void;
export type AddProductToCatalogConfigManagerCloudServicesApiV1ProductCatalogPostApiResponse =
  /** status 200 Successful Response */ ProductCatalogRead;
export type AddProductToCatalogConfigManagerCloudServicesApiV1ProductCatalogPostApiArg = {
  productCatalogBase: ProductCatalogBase;
};
export type AccountWithRoles = {
  accountId: string;
  roles: string[];
  permissions: string[];
  status: string;
  name?: string | null;
  type?: string | null;
  membershipStatus?: string | null;
  parentAccountId?: string | null;
  inherited?: boolean;
};

export type SwitchCurrentAccountApiResponse = /** 200 */ UserRead;
export type SwitchCurrentAccountApiArg = {
  accountId: string;
};
export type CreateOrganizationAccountApiResponse = /** 200 */ AccountRead;
export type CreateOrganizationAccountApiArg = {
  name: string;
};
export type MemberRead = {
  userId: string;
  email?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  roles: string[];
  permissions: string[];
  status: string;
};
export type RoleRead = {
  role: string;
  label: string;
  description: string;
  permissions: string[];
  assignable: boolean;
};
export type ListRolesApiResponse = /** 200 */ RoleRead[];
export type ListRolesApiArg = void;
export type InvitationRead = {
  id: string;
  email: string;
  accountId: string;
  role: string;
  status: string;
  expiresAt?: string | null;
  invitedBy?: string | null;
  createdAt?: string | null;
};
export type InvitationCreated = InvitationRead & {
  token: string;
  acceptUrl: string;
};
export type CreateInvitationApiResponse = /** 200 */ InvitationCreated;
export type CreateInvitationApiArg = {
  accountId: string;
  invitation: { email: string; role: string };
};
export type ListInvitationsApiResponse = /** 200 */ InvitationRead[];
export type ListInvitationsApiArg = {
  accountId: string;
};
export type AcceptInvitationApiResponse = /** 200 */ {
  accountId: string;
  role: string;
  message: string;
};
export type AcceptInvitationApiArg = {
  token: string;
};
export type DeclineInvitationApiResponse = /** 200 */ {
  [key: string]: any;
};
export type DeclineInvitationApiArg = {
  token: string;
};
export type RevokeInvitationApiResponse = /** 200 */ InvitationRead;
export type RevokeInvitationApiArg = {
  accountId: string;
  invitationId: string;
};
export type ResendInvitationApiResponse = /** 200 */ InvitationRead;
export type ResendInvitationApiArg = {
  accountId: string;
  invitationId: string;
};
export type SetCurrentAccountMemberStatusApiResponse = /** 200 */ {
  [key: string]: any;
};
export type SetCurrentAccountMemberStatusApiArg = {
  userEmail: string;
  newStatus: string;
};
export type AuditInfo = {
  createdDate?: string | null;
  lastModifiedDate?: string | null;
  createdBy?: string | null;
  lastModifiedBy?: string | null;
};
export type UserRead = {
  id: string;
  email: string;
  firstName?: string | null;
  lastName?: string | null;
  locale?: string | null;
  theme?: string | null;
  accounts?: AccountWithRoles[];
  auditInfo: AuditInfo;
  currentAccount?: string | null;
};
export type ValidationError = {
  loc: (string | number)[];
  msg: string;
  type: string;
};
export type HttpValidationError = {
  detail?: ValidationError[];
};
// export type AccountStatus = 'ACTIVE' | 'BOOTSTRAP' | 'MISSING_DETAILS' | 'READY';
export type AccountRead = {
  name?: string | null;
  status?: AccountStatus | null;
  type?: string | null;
  slug?: string | null;
  parent_account_id?: string | null;
  logoUrl?: string | null;
  company?: string | null;
  email?: string | null;
  phone?: string | null;
  id: string;
  auditInfo: AuditInfo;
};
export type SubAccountRead = {
  id: string;
  name?: string | null;
  status: string;
  type: string;
  memberCount: number;
};
export type ListSubAccountsApiResponse = /** 200 */ SubAccountRead[];
export type ListSubAccountsApiArg = void;
export type CreateSubAccountApiResponse = /** 200 */ AccountRead;
export type CreateSubAccountApiArg = {
  name: string;
};
export type SubscriptionRead = {
  account_id: string;
  productCatalogId: string;
  status?: string | null;
  id: string;
};
export type SubscriptionCreate = {
  accountId: string;
  productCatalogId: string;
  status?: string | null;
  id?: string;
};
export type Currency = 'EUR' | 'GBP' | 'USD';
export type BillingProfileRead = {
  accountId: string;
  id: string;
  address1?: string | null;
  address2?: string | null;
  city?: string | null;
  state?: string | null;
  postalCode?: string | null;
  country?: string | null;
  currency?: Currency | null;
  locale?: string | null;
};
export type ProductCatalogRead = {
  name: string;
  version: string;
  id: string;
};
export enum AccountStatus {
  ACTIVE = 'ACTIVE',
  BOOTSTRAP = 'BOOTSTRAP',
  MISSING_DETAILS = 'MISSING_DETAILS',
  READY = 'READY',
}
export type ProductCatalogBase = {
  name: string;
  version: string;
};
